import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function Logout({ ...props }) {
  const history = useHistory();

  useEffect(() => {
    localStorage.clear();

    history.push("/login");
  }, []);

  return <></>;
}
